import {
  Edit,
  SimpleForm,
  TextInput,
  Toolbar,
  SaveButton,
  useRecordContext,
  useTranslate,
} from 'react-admin';
import { Box, Typography } from '@mui/material';
import type { Channel } from '../../types/chat.types';

const ChannelEditToolbar = () => (
  <Toolbar>
    <SaveButton />
  </Toolbar>
);

const ChannelEditForm = () => {
  const record = useRecordContext<Channel>();
  const translate = useTranslate();

  if (!record) return null;

  return (
    <>
      <Box mb={2}>
        <Typography variant="h6">
          {translate('resources.channel.edit.title')}: {record.name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {translate(`resources.channel.types.${record.type}`)}
        </Typography>
      </Box>

      <TextInput
        source="name"
        label={translate('resources.channel.fields.name')}
        fullWidth
        required
      />
    </>
  );
};

export const ChannelEdit = () => {
  return (
    <Edit>
      <SimpleForm toolbar={<ChannelEditToolbar />}>
        <ChannelEditForm />
      </SimpleForm>
    </Edit>
  );
};
